/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Japanese
export default {
  'confluence-analytics-byline.abbreviated-user-views.message': '{count, plural, =0 {閲覧数} other {{count}}}',
  'confluence-analytics-byline.page-viewers.message': '閲覧者',
  'confluence-analytics-byline.user-views.message': '{count, plural, =0 {分析} other {{count} 人が閲覧}}',
};
